import {Component, EventEmitter, inject, Input, OnDestroy, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {DialogService, FileService, NotificationService} from "@wms/services";
import {BaseComponent, WmsMessageComponent} from "@wms/components";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'wms-add-custom-icon-template',
  standalone: true,
  imports: [CommonModule, FormsModule, WmsMessageComponent],
  templateUrl: './add-custom-icon-template.component.html',
  styleUrls: ['./add-custom-icon-template.component.less']
})
export class AddCustomIconTemplateComponent extends BaseComponent implements OnDestroy{
  @Input() dialogeAction: any;
  @Input() ttfFile: string = "";
  @Input() cssFile: string = "";
  @Input() showUploadFont: boolean;
  @Output() enableDialogeAction = new EventEmitter<any>();
  @Output() refreshResourceDialoge = new EventEmitter<any>();
  @Output() goBacktoResource = new EventEmitter<any>();
  errorMessage:any = {type:'error',caption:this.locale.MESSAGE_ERROR_ICONFILE_NAME_EXISTS_DESC}
  showErrorMsg: boolean = false;
  libName: string = "";
  ttfFileSource: any;
  cssFileSource: any;
  dialogeService: DialogService
  fileService: FileService;
  fileName: any;
  folder: any;
  isHandlingEvent:boolean = false;
  notificationService: NotificationService

  constructor() {
    super();
    this.dialogeService = inject(DialogService);
    this.fileService = inject(FileService);
    this.notificationService = inject(NotificationService);
    this.registerDestroyListener.add(this.eventManager.updateOnIconSave().subscribe(() => {
      this.validateFileName()


    }));
  }


  removeFile(fileType: any) {
    fileType === 'ttf' ? this.ttfFile = '' : this.cssFile = '';
    this.enableDialogeAction.emit({
      fileType: fileType,
      value: fileType === 'ttf' ? this.ttfFile = '' : this.cssFile = ''
    });
  };

  validateTTFFile($ele: any) {
    this.ttfFileSource = $ele.target.files;
    this.ttfFile = this.getFile($ele.target);
    this.enableDialogeAction.emit({fileType: 'ttf', value: this.ttfFile});

  };

  validateCSSFile($ele: any) {
    this.cssFileSource = $ele.target.files;
    this.cssFile = this.getFile($ele.target);
    this.enableDialogeAction.emit({fileType: 'css', value: this.cssFile});
  };

  getFile($ele: any) {
    let value;
    if ($ele.files) {
      if ($ele.files[0]) {
        value = $ele.files[0].name;
      }
    } else {
      value = $ele.value;
      if (value) {
        value = value.substr(value.lastIndexOf("\\") + 1);
      }
    }
    return value;
  }

  getFileContent(url: string) {
    return this.fileService.read(url, true);
  }

  saveFileContent(url: string, content: any) {
    return this.fileService.write(url, content)

  }
  checklibname(libname: string) {
    if(libname.length === 0){
      this.showErrorMsg = false;
    }
  this.enableDialogeAction.emit({fileType: 'libName', value: libname})
  }

  validateFileName(){
    let exists = false;
if( this.fileService.storeIconFamiliesList) {
  for (const item of this.fileService.storeIconFamiliesList) {
    if (item.name.toLowerCase() === this.libName.toLowerCase()) {
      exists = true;
      break;
    }
  }
}

    if (!exists) {
      this.saveFontIcon()
    } else {
      this.showErrorMsg = true;
    }
  }

  saveFontIcon() {

    this.fileName = this.ttfFile;
    this.folder = 'resources/icons/' + this.libName;
    // upload the resources


    this.uploadResource(this.ttfFileSource);
    let file = this.cssFileSource[0];

    if (file) {
      let reader = new FileReader();
      reader.readAsText(file, "UTF-8");
      reader.onload = (evt: any) => {
        let fileContent: any = evt.target.result
        let pattern = /\.([^\s:]+):before/g,
          matches: any = [], match;
        for (let i = 0; (match = pattern.exec(fileContent)) !== null; i++) {
          matches.push(match[1]);
        }
        let updatedCSSContent = fileContent.replace(/(@font-face[^}]*)/, '$1\n  src: url( ' + this.ttfFile + ');');
        let path = 'resources/icons/designer.js';
        this.getFileContent(path).then((result) => {
          result = result.replace('export default ', '');
          result = JSON.parse(result);
          result[this.libName] = matches;
          return this.saveFileContent(path, 'export default ' + JSON.stringify(result)).then((res) => {
            return this.saveFileContent('resources/icons/' + this.libName + '/' + this.cssFile, updatedCSSContent).then(() => {
              this.successCallback();
           this.goBacktoResource.emit()
            });
          });
        }, () => {
          let icons: any = {};
          icons[this.libName] = matches;
          return this.saveFileContent(path, 'export default ' + JSON.stringify(icons)).then((res) => {
            return this.saveFileContent('resources/icons/' + this.libName + '/' + this.cssFile, updatedCSSContent).then(() => {
              this.successCallback()
              this.goBacktoResource.emit()
            });
          });
        });
      };
    }


    this.getFileContent('font.config.js').then((result) => {
      this.updateFontConfig(result);
    }, (error: any) => {
      if(error.status === 404) {
        const fontConfig = `export default {
            baseFont: '',
            fonts: [
                /**
                 * {
                 *  name: fontName,
                 *  path: 'relative (from webapp) path of font files in webapp folder.'
                 * }
                 */
            ]
        };`
        this.updateFontConfig(fontConfig);
      }
    });

    // On success, uploadResource API returns nothing(undefined) and in case of any
    // error/failure, we explicitly return false.

  }

  updateFontConfig(fontConfig: any) {
    let fontIcon = {
      name: this.libName,
      path: "resources/icons/" + this.libName + "/" + this.ttfFile,
      csspath: "resources/icons/" + this.libName + "/" + this.cssFile,
    };
    let fonts = fontConfig.split(']');
    fonts[0] = fonts[0] + JSON.stringify(fontIcon) + ',';
    fontConfig = fonts.join(']');
    return this.saveFileContent('font.config.js', fontConfig).then((res) => {

    });
  }

  successCallback() {
    this.ttfFile = "";
    this.cssFile = "";
    this.libName = "";
    let path = 'resources/icons';
    if (this.dialogeAction) {
      this.eventManager.emitOnIconImport()
      this.onClose();
    } else {
      this.refreshResourceDialoge.emit(path)

    }
    this.notificationService.show("success", this.locale["TITLE_WRITE_CONFIG_SUCCESS"], this.locale["MESSAGE_SUCCESS_ICON_IMPORT_DESC"]);
  }

  onClose() {
    this.dialogeService.close('importIconsDialoge')
  }

  uploadResource(selectedFile: any) {
    if (this.validateResource(selectedFile)) {
      this.getUploadConfig(selectedFile);
    }
  }

  validateResource(selectedFiles: FileList): boolean {
    let restrictedPaths: string[] = [
      '../lib/project-external-dependency-jars',
      '../project/lib/project-external-dependency-jars',
      '../project/generated-angular-app'
    ];
    let isRestrictedPath: string | undefined = restrictedPaths.find((restrictedPath: string) => {
      return this.folder.startsWith(restrictedPath);
    });
    if (isRestrictedPath) {
      this.notificationService.show("error", this.locale["MESSAGE_ERROR_TITLE"], this.locale["MESSAGE_ERROR_UPLOAD_NOT_ALLOWED"]);
      return false;
    }
    if (selectedFiles?.length === 0) {
      console.log("emptyFile")
      // this.toggleMessage(this.locale["MESSAGE_ERROR_NO_FILE_SELECTED_DESC"], "error");
      return false;
    }

    return true;
  }

  getUploadConfig(selectedFiles: FileList): any {
    let formData: FormData = new FormData();
    if (selectedFiles.length > 1) {
      for (let k: number = 0; k < selectedFiles.length; k++) {
        formData.append("file" + k, selectedFiles[k]);
      }
    } else {
      formData.append("file", selectedFiles[0]);
    }
    let uploadConfig = {
      action: 'upload',
      path: this.folder,
      content: formData
    };
    this.fileService.upload(uploadConfig).then((res) => {

    })


  }

  goBack() {
    this.goBacktoResource.emit()
    this.showUploadFont = false;
  }

  override ngOnDestroy() {
    this.registerDestroyListener.unsubscribe();
  }

}
